declare namespace $ {

	export class $mol_icon_code_braces extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=braces.view.tree.d.ts.map